import React, { useEffect, useState } from 'react';
import { FormFieldConfig } from '../../Hooks/useForm';
import { getGuid } from '../../Utils/stringUtils';

export type BizInputProps = {
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
	value: string;
	name?: string;
	placeholder?: string;
	className?: string;
	formConfig?: FormFieldConfig<string>;
	type?: React.HTMLInputTypeAttribute;
	readonly?: boolean;
	legacy?: boolean;
	min?: string;
	max?: string;
};

const BizInput = ({
	onChange,
	onBlur,
	value,
	placeholder,
	className,
	type: pType,
	formConfig,
	name: pName,
	readonly,
	legacy,
	min,
	max,
}: BizInputProps) => {
	const [name] = useState(pName ?? getGuid());
	const isValid = formConfig?.state.fields[name]?.isValid ?? true;

	useEffect(() => {
		if (!formConfig || !formConfig.validators) return;

		const newIsValid = formConfig.state.validateFieldValue(value, formConfig.validators);
		if (newIsValid !== isValid) {
			formConfig.state.setFieldValid(name, newIsValid, formConfig.group);
		}
	}, [value, formConfig?.validators]);

	function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
		onChange(e);
		if (formConfig && !formConfig.state.isDirty) {
			formConfig.state.setDirty();
		}
	}

	function handleBlur(e: React.FocusEvent<HTMLInputElement>) {
		if (onBlur) {
			onBlur(e);
		}
	}

	let currentClasses = className ?? '';
	if (!isValid) {
		currentClasses += ' invalid';
	}

	if (!legacy) {
		currentClasses += ' biz-input';
	}

	const type = pType ?? 'text';

	return (
		<input
			type={type}
			className={currentClasses}
			placeholder={placeholder}
			value={value}
			name={name}
			onChange={handleChange}
			readOnly={readonly}
			min={min}
			max={max}
			onBlur={handleBlur}
		/>
	);
};

export default BizInput;
